import PartnerTripsContainer from './trips-container';

export default PartnerTripsContainer;
